import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import loadTranslations from 'js/localeSetup';

import EmailStep from './steps/EmailStep';
import InterestStep from './steps/InterestStep';
import ConfirmStep from './steps/ConfirmStep';
import gtmPusher from '../utils/gtmPusher';
import client from '../utils/client';

import './style.scss';

export default class Signup extends PureComponent {
  constructor(props) {
    super(props);
    this.handleData = this.handleData.bind(this);
    this.convertToJSON = this.convertToJSON.bind(this);
    this.state = {
      stepNumber: 1,
      email: '',
      interestData: [],
      device: window.innerWidth > 768 ? 'desktop' : 'mobile',
      source: 'footer',
    };
  }

  handleData(data) {
    switch (this.state.stepNumber) {
      case 1:
        this.setState({
          email: data,
          stepNumber: 2,
        });
        break;
      case 2:
        this.setState({
          interestData: data,
          stepNumber: 3,
        });
        window.setTimeout(() => {
          this.convertToJSON();
        }, 100);
        break;
      default:
        break;
    }
  }

  convertToJSON() {
    const data = {
      email: this.state.email,
      device: this.state.device,
      source: this.state.source,
      interest_categories: this.state.interestData,
    };

    client
      .post('/checkout/subscribe_for_news/', data)
      .then(() => {
        const gaObj = {
          event: 'newsletterSubscription',
          eventCategory: 'newsletter',
          eventAction: data.interest_categories[0].types.join(','),
          eventLabel: 'success',
          eventValue: 0,
          eventNonInteraction: false,
        };
        gtmPusher(gaObj, null);
      })
      .catch(() => {
        const gaObj = {
          event: 'newsletterSubscription',
          eventCategory: 'newsletter',
          eventAction: data.interest_categories[0].types.join(','),
          eventLabel: 'error',
          eventValue: 0,
          eventNonInteraction: false,
        };
        gtmPusher(gaObj, null);
      });
  }

  render() {
    return (
      <main className="newsletter-main">
        {this.state.stepNumber === 1 ? (
          <EmailStep flag={this.props.flag} onNextClick={this.handleData} />
        ) : null}
        {this.state.stepNumber === 2 ? (
          <InterestStep onNextClick={this.handleData} />
        ) : null}
        {this.state.stepNumber === 3 ? (
          <ConfirmStep onNextClick={this.handleData} />
        ) : null}
      </main>
    );
  }
}

(async () => {
  const rootElement = document.getElementById('newsletter');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<Signup />, rootElement);
  }
})();
